import auth0 from "auth0-js";
import { EventEmitter } from "events";

const webAuth = new auth0.WebAuth({
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  audience: process.env.VUE_APP_AUTH0_AUDIENCE,
  redirectUri: `${window.location.origin}/callback`,
  clientID: process.env.VUE_APP_AUTH0_CLIENT_ID,
  responseType: "token",
  scope: "openid profile email"
});

const loginEvent = "loginEvent";

class AuthService extends EventEmitter {
  login(customState) {
    webAuth.authorize({
      appState: customState
    });
  }

  logOut() {
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('tokenExpiry');

    webAuth.logout({
      returnTo: `${window.location.origin}`
    });

    this.emit(loginEvent, { loggedIn: false });

    window.location.href = process.env.VUE_APP_OLD_URL + '/auth/logout';
  }

  handleAuthentication() {
    return new Promise((resolve, reject) => {
      webAuth.parseHash((err, authResult) => {
        if (err) {
          reject(err);
        } else {
          if (authResult && authResult.accessToken) {
            this.localLogin(authResult);
            resolve(authResult.accessToken);
          } else {
            reject({error: "access_token_missing", errorDescription: "The access token is missing. Log out and try again."});
          }
        }
      });
    });
  }

  isAuthenticated() {
    return (
      sessionStorage.getItem('accessToken') &&
      sessionStorage.getItem('tokenExpiry') &&
      Date.now() < parseInt(sessionStorage.getItem('tokenExpiry'))
    );
  }

  getAccessToken() {
    return new Promise((resolve, reject) => {
      if (this.isAuthenticated()) {
        resolve(sessionStorage.getItem('accessToken'));
      } else {
        this.renewTokens()
          .then(authResult => {
            resolve(authResult.accessToken);
          })
          .catch(function () {
            resolve();
          })
      }
    });
  }

  localLogin(authResult) {
    sessionStorage.setItem('accessToken', authResult.accessToken);
    sessionStorage.setItem('tokenExpiry', (Date.now() + (authResult.expiresIn*1000)).toString());

    this.emit(loginEvent, {
      loggedIn: true,
      state: authResult.appState || {}
    });
  }

  renewTokens() {
    return new Promise((resolve, reject) => {
      if (!sessionStorage.getItem('accessToken') || sessionStorage.getItem('accessToken') === null) {
        return reject("Not logged in");
      }

      webAuth.checkSession({}, (err, authResult) => {
        if (err) {
          reject(err);
        } else {
          this.localLogin(authResult);
          resolve(authResult);
        }
      });
    });
  }
}

const service = new AuthService();

service.setMaxListeners(5);

export default service;
